/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1SMQueryItem
 */
export interface V1SMQueryItem {
    /**
     *
     */
    labels?: { [key: string]: string }
    /**
     *
     */
    values: { [key: string]: number }
}

/**
 * Check if a given object implements the V1SMQueryItem interface.
 */
export function instanceOfV1SMQueryItem(value: object): value is V1SMQueryItem {
    if (!('values' in value) || value['values'] === undefined) return false
    return true
}

export function V1SMQueryItemFromJSON(json: any): V1SMQueryItem {
    return V1SMQueryItemFromJSONTyped(json, false)
}

export function V1SMQueryItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1SMQueryItem {
    if (json == null) {
        return json
    }
    return {
        labels: json['labels'] == null ? undefined : json['labels'],
        values: json['values']
    }
}

export function V1SMQueryItemToJSON(json: any): V1SMQueryItem {
    return V1SMQueryItemToJSONTyped(json, false)
}

export function V1SMQueryItemToJSONTyped(
    value?: V1SMQueryItem | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        labels: value['labels'],
        values: value['values']
    }
}
